import React, {useContext, useState} from 'react';
import {
    startOfMonth,
    endOfMonth,
    eachDayOfInterval,
    format,
    addMonths,
    getDay,
    addDays,
    isToday
} from 'date-fns';
import { ru } from 'date-fns/locale';
import styles from './calendar.module.scss';
import arrow from '../../arrowLong.svg';
import DataOfDayTable from "./DataOfDayTable";
import { getDayScheduleData } from './api/calenparApi';
import {EmployeeContext} from "../../context/EmployeeContext.jsx";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import useIsMobile from "@/shared/lib/hooks/useIsMobile";
import common from "../../common.module.scss";


export default function Calendar() {
    const { employee } = useContext(EmployeeContext);
    const role = employee?.role;

    const navigate = useNavigate();

    const isMobile = useIsMobile();

    const [monthOffset, setMonthOffset] = useState(0);
    const [selectedDay, setSelectedDay] = useState(null);

    const [dayData, setDayData] = useState([]);

    const baseDate = new Date();
    const currentMonthDate = addMonths(baseDate, monthOffset);

    const start = startOfMonth(currentMonthDate);
    const end = endOfMonth(currentMonthDate);

    // Сдвиг к понедельнику
    const startWeekDay = getDay(start) === 0 ? 6 : getDay(start) - 1;
    const endWeekDay = getDay(end) === 0 ? 6 : getDay(end) - 1;
    const daysBefore = startWeekDay; // сколько дней из прошлого месяца
    const daysAfter = 6 - endWeekDay; // сколько из следующего

    const calendarStart = addDays(start, -daysBefore);
    const calendarEnd = addDays(end, daysAfter);

    const days = eachDayOfInterval({ start: calendarStart, end: calendarEnd });

    const monthName = format(currentMonthDate, 'LLLL', { locale: ru });

    const getDayData = async (day) => {
        try {
            const res = await getDayScheduleData(day);
            const data = res.data.content;

            setDayData(data);
        }
        catch(e) {
            const errorMessage =
                e?.response?.data?.message || 'Ошибка при загрузке расписания';
            toast.error(errorMessage);
        }
    }

    const handleDayClick = (day) => {
        setSelectedDay(day);
        getDayData(day)
    }

    return (
        <div className="container-fluid">
            {isMobile && (<h1 className={`${common.mobileHeading} mt-5`}>Календарь</h1>)}
            <div className={"row justify-content-between g-0"}>
                <div className={styles.calendar + " col-md-4 col-12"}>
                    <div className={styles.header}>
                        <button
                            onClick={() => setMonthOffset((offset) => Math.max(-1, offset - 1))}
                            disabled={monthOffset === -1}
                            className={styles.backArrow}
                        >
                            <img src={arrow} alt="предыдущий месяц" />
                        </button>
                        <p className="body">{monthName}</p>
                        <button
                            onClick={() => setMonthOffset((offset) => Math.min(1, offset + 1))}
                            disabled={monthOffset === 1}
                        >
                            <img src={arrow} alt="следующий месяц" />
                        </button>
                    </div>

                    <div className={styles.grid}>
                        {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((day) => (
                            <div key={day} className={styles.dayName}>{day}</div>
                        ))}

                        {days.map((day) => {
                            const isCurrentMonth = day.getMonth() === currentMonthDate.getMonth();
                            const isSelectedDay = selectedDay && format(day, "yyyy-MM-dd") === format(selectedDay, 'yyyy-MM-dd');
                            return (
                                <div
                                    key={day.toISOString()}
                                    className={`${styles.day}  ${!isCurrentMonth ? styles.otherMonth : ''}`}
                                    onClick={()=> {handleDayClick(format(day, "yyyy-MM-dd'T'00:00:00"))}}>
                                    <div className={`${isSelectedDay ? styles.selectedDay : ''} ${isToday(day) ? styles.today : ''}  ${styles.numWrapper}`}>
                                        {format(day, 'd')}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {role !== "ADMIN" && role !== "MASTER" && !isMobile && (
                    <button
                        className="service-btn col-auto h-25 mt-4"
                        onClick={() => navigate('/admin/schedule/create')}
                    >
                        Добавить игру
                    </button>
                )}
            </div>
            {
                selectedDay && (
                    <DataOfDayTable dataOfDay={dayData} setDataOfDay={setDayData} />
                )
            }
            {role !== "ADMIN" && role !== "MASTER" && isMobile && (
                <button
                    className="service-btn col-auto h-25 mt-4 w-100 mb-4"
                    onClick={() => navigate('/admin/schedule/create')}
                >
                    Добавить игру
                </button>
            )}
        </div>
    );
}
